// extracted by mini-css-extract-plugin
module.exports = {"window":"ConfirmModal_window__pt5fW","windowHeader":"ConfirmModal_windowHeader__3Vrie","windowSubheader":"ConfirmModal_windowSubheader__3KiYN"};